import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { HeaderResponse, NavMenuColumn } from '@digital-platform/rs-cms/domain';
import { RichTextLinkComponent } from '@digital-platform/rs-cms/feature-ptypes';

@Component({
  selector: 'digital-platform-desktop-nav-list',
  templateUrl: './desktop-nav-list.component.html',
  styleUrls: ['./desktop-nav-list.component.scss'],
  standalone: true,
  imports: [CommonModule, RichTextLinkComponent],
})
export class DesktopNavListComponent {
  @Input() menuKeys: string[] = [];
  @Input() config: HeaderResponse[0] | null = null;
  @Input() activeMenu: NavMenuColumn[] | null = null;
  @Output() activeMenuChange = new EventEmitter<NavMenuColumn | null>();
  @Output() hoverStart = new EventEmitter<NavMenuColumn[]>();
  @Output() hoverEnd = new EventEmitter<void>();

  startHover(menu: NavMenuColumn[]): void {
    this.hoverStart.emit(menu);
  }

  endHover(): void {
    this.hoverEnd.emit();
  }

  getMenuItem(key: string): any[] {
    return (this.config as { [key: string]: any })[key];
  }
}
